<template>
	<div id="app" :class="[{'loading-new-data': loadingNewData}, currentView]" role="main">
        <site-header />
        <landing-page v-if="init && ($route.name == 'home' || $route.name === 'index')" />
        <div class="loader" v-if="!init || loadingNewData">Loading...</div>
        <breadcrumb v-if="init" />
        <top-filters
            @setTableData="setTableData"
            @filterRcdc="filterRcdc"
            v-if="init"
        />
        <router-view
            v-if="init"
            class="app__view-wrapper"
            :class="{'fade-when-loading': loadingNewData}"
            ref="view"
        />
        <site-footer v-if="init && currentView !== 'ic'" />
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import globalMixins from '@/js/globalMixins';
import SiteHeader from '@/components/SiteHeader';
import Breadcrumb from '@/components/Breadcrumb';
import TopFilters from '@/components/TopFilters';
import LandingPage from '@/components/LandingPage';
import SiteFooter from '@/components/SiteFooter';
import bus from '@/js/event-bus.js';
export default {
    name: 'App',
    mixins: [globalMixins],
    components: {
        SiteHeader,
        Breadcrumb,
        TopFilters,
        LandingPage,
        SiteFooter
    },
    computed: {
        ...mapGetters([
            'yearsData',
            'topFilterPresets',
            'selectedYear',
            'loadingNewData',
        ])
    },
    data: function () {
        return {
            init: false,
            count: 0
        };
    },
    mounted () {

        if (window.isIE) {
            $('body').addClass('ie');
        }

        $.getJSON('data/topfilterpresets.json', (data) => {
            this.count++;
            this.init = this.count === 2;
            this.setTopFilterData(data);
        });

        let yearStr = this.selectedYear > 2021 ? this.selectedYear + '/' : '',
            allFyData = [];
        this.getSelectedYearData(yearStr + this.selectedYear).done((data) => {
            let fyRecord = _.filter(this.topFilterPresets.fiscalYears, (fyRec) => {
                return fyRec.value === this.selectedYear;
            });
            if (fyRecord.length > 0 && fyRecord[0].fileCount && fyRecord[0].fileCount > 1) {
                allFyData = allFyData.concat(data);
                for (let i = 0; i < fyRecord[0].fileCount-1; i++) {
                    this.getSelectedYearData(yearStr + this.selectedYear + '_' + (i+1)).done((partData) => {
                        this.count++;
                        allFyData = allFyData.concat(partData);
                        if (this.count === fyRecord[0].fileCount) {
                            this.setYearsData({'year': this.selectedYear, 'data': allFyData});
                            this.init = true;
                        }
                    });
                }
            } else {
                this.count++;
                this.setYearsData({'year': this.selectedYear, 'data': data});
                this.init = this.count === 2;
            }
        });
    },
    methods: {
        ...mapActions([
            'setYearsData',
            'setTopFilterData',
            'setRcdcFilterValue'
        ]),
        setTableData () {
            bus.$emit('setTableData');
        },
        filterRcdc () {
            this.$refs.view.filterRcdc();
        }
    }
};
</script>

<style lang="scss">
@import '@/scss/main.scss';
#app {
    height: 100%;
    position: relative;
    padding: $home-page-padding 0 0 0;
    overflow: hidden;
    transition: $tran-speed;

    > .loader {
        top: 200px;
    }

    > .landing-page.show ~ .loader {
        top: 500px;
    }

    &.loading-new-data {
        .fade-when-loading {
            opacity: $opacity;
        }
    }

    &.ic {
        padding: $home-page-padding 0;
        .app__view-wrapper {
            height: calc(100% - 40px);
            overflow: auto;
        }
    }

    &.rcdc {
        .app__view-wrapper {
            height: calc(100% - #{$footer-height} - 40px);
        }
    }
}

.app__view-wrapper {
    background: #fff;
    height: calc(100% - #{$footer-height});
    overflow: hidden;
    padding: 0;
    position: relative;
    transition: 0.3s;
}
</style>
